import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React from 'react';

import styles from './index.module.scss';

export class LinkButton extends React.PureComponent<ButtonProps> {
  render(): React.ReactNode {
    const {
      children,
      disabled,
      loading,
      onClick,
      icon
    } = this.props;
    return <div className={styles.container}>
      <Button
        type="link"
        htmlType="submit"
        className={styles.linkButton}
        disabled={disabled}
        loading={loading}
        onClick={onClick}
        icon={icon}
        {...this.props}
      >
        {children}
      </Button>
    </div>;
  }
}
